const environment = {
    // apiUrl: 'https://localhost:44318/api/', // local

    apiUrl: 'https://redeem-chh-api.objective-faraday.119-59-118-127.plesk.page/api/', // VPS

    // apiUrl: 'https://tgq-apiredemption.tgh.co.th/api/', // Production
    
}
export default environment
